import { useQuery } from '@tanstack/react-query';
import { propertyAttributeServices } from '../services/propertyAttribute.service';

const parseApiError = (error) => ({
  message:
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    'Something went wrong',
  status: error?.response?.status || 500,
  errors: error?.response?.data?.errors || [],
});

export const usePropertyAttributes = (filters) => {
  return useQuery({
    queryKey: ['property-attributes', filters],
    queryFn: async () => {
      try {
        return await propertyAttributeServices.getPropertyAttributes(filters);
      } catch (error) {
        throw parseApiError(error);
      }
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    placeholderData: (previousData) => previousData,
    retry: 1,
  });
};
